import React, { useEffect, useState } from "react";
import './SalaryReport.css';

import { Table, Button } from "react-bootstrap";
import axios from "axios";

import { jsPDF } from "jspdf";
import "jspdf-autotable";

const SalaryReport = () => {
    const [employeeSalary, setEmployeeSalary] = useState([]);

    useEffect(() => {
        const fetchEmployeeSalary = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/api/salary/report`
                );
                // Sort the fetched data by employeeId numerically
                const sortedData = response.data.sort((a, b) => {
                    // Extract the numeric part of employeeId and compare them
                    const idA = parseInt(a.employeeId.replace(/\D/g, '')); // Remove non-numeric characters
                    const idB = parseInt(b.employeeId.replace(/\D/g, '')); // Remove non-numeric characters
                    return idA - idB;
                });
                setEmployeeSalary(sortedData);
            } catch (error) {
                console.error("Error fetching employee salary report:", error);
            }
        };

        fetchEmployeeSalary();
    }, []);
    const downloadExcel = async () => {
        const ExcelJS = require('exceljs');
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Salary Report');
    
        const reportDate = new Date().toLocaleString('default', { month: 'long', year: 'numeric' });
    
        // Merge A1:H1 and add title
        worksheet.mergeCells('A1:H1');
        worksheet.getCell('A1').value = 'Salary Report';
        worksheet.getCell('A1').alignment = { horizontal: 'center' };
        worksheet.getCell('A1').font = {
            bold: true,
            size: 16,
            color: { argb: 'F7912B' }
        };
    
        // Merge A2:H2 and add month
        worksheet.mergeCells('A2:H2');
        worksheet.getCell('A2').value = `Month: ${reportDate}`;
        worksheet.getCell('A2').alignment = { horizontal: 'center' };
        worksheet.getCell('A2').font = {
            italic: true,
            size: 12,
            color: { argb: '333333' }
        };
    
        // Header row (in row 3)
        const headerRow = worksheet.addRow([
            "S.No", "EmployeeId", "EmployeeName", "Designation",
            "Bank Account Number", "Working Days", "Gross Salary", "Payable"
        ]);
    
        // Style header
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.alignment = { horizontal: 'center' };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'F7912B' }
            };
        });
    
        // Data rows
        employeeSalary.forEach((employee, index) => {
            const row = worksheet.addRow([
                index + 1,
                employee.employeeId,
                employee.employeeName,
                employee.designation,
                employee.bankAccountNumber,
                employee.workingDays,
                parseFloat(employee.grossSalary).toFixed(2),
                employee.workingDays - employee.absentDays
            ]);
    
            row.getCell(1).alignment = { horizontal: 'center' };
            row.getCell(7).alignment = { horizontal: 'right' };
            row.getCell(5).alignment = { horizontal: 'right' };
        });
    
        worksheet.columns = [
            { width: 10 },
            { width: 15 },
            { width: 20 },
            { width: 15 },
            { width: 25 },
            { width: 15 },
            { width: 15 },
            { width: 15 }
        ];
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'salary_report.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
    };
    



    const downloadPDF = () => {
        const doc = new jsPDF();
        const reportDate = new Date().toLocaleString('default', { month: 'long', year: 'numeric' });
    
        // Add title and date
        doc.setFontSize(18);
        doc.text("Salary Report", 80, 22);
        doc.setFontSize(12);
        doc.text(`Month: ${reportDate}`, 85, 30);  // Show the month below the title
    
        // Table starts below date
        const startY = 38;
    
        const columns = [
            "S.No", "EmployeeId", "EmployeeName", "Designation", "Bank Account Number",
            "Working Days", "Gross Salary", "Payable"
        ];
    
        const data = employeeSalary.map((employee, index) => [
            index + 1,
            employee.employeeId,
            employee.employeeName,
            employee.designation,
            employee.bankAccountNumber,
            employee.workingDays,
            parseFloat(employee.grossSalary).toFixed(2),
            employee.workingDays - employee.absentDays
        ]);
    
        doc.autoTable({
            head: [columns],
            body: data,
            startY,
            styles: {
                halign: 'center',
                fontSize: 10,
                cellWidth: 'auto',
                valign: 'middle',
            },
            headStyles: {
                fillColor: [255, 165, 0],
                textColor: [255, 255, 255],
                fontStyle: 'bold',
            }
        });
    
        doc.save("salary_report.pdf");
    };
    
    return (
        <div className="salaryreport-main">
            <div className="salaryreport-head">
                <h4>Salary Report</h4>
            </div>
            <div className="btn-date">
                <div className="current-month">
                    <h4>{new Date().toLocaleString('default', { month: 'long', year: 'numeric' })}</h4>
                </div>
                <div className="download-buttons">
                    <Button variant="primary" onClick={downloadPDF}>Download PDF</Button>
                    <Button variant="success" onClick={downloadExcel}>Download Excel</Button>
                </div>
            </div>
            <div className="salaryreport-container">
           
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>EmployeeId</th>
                                <th>EmployeeName</th>
                                <th>Designation</th>
                                <th>Bank Account Number</th>
                                <th>Working Days</th>
                                <th>Gross Salary</th>
                                <th>Payable</th>
                            </tr>
                        </thead>
                        <tbody>
                            {employeeSalary && employeeSalary.length > 0 ? (
                                employeeSalary.map((employee, index) => (
                                    <tr key={employee.employeeId}>
                                        <td>{index + 1}</td>
                                        <td>{employee.employeeId}</td>
                                        <td>{employee.employeeName}</td>
                                        <td>{employee.designation}</td>
                                        <td>{parseInt(employee.bankAccountNumber)}</td>
                                        <td>{employee.workingDays}</td>
                                        <td>{parseFloat(employee.grossSalary).toFixed(2)}</td>
                                        <td>{employee.workingDays - employee.absentDays}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">No salary data available</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
            </div>
        </div>
    );
};

export default SalaryReport;
